import React from "react";
import { NavLink } from "react-router-dom";

import StoreFrontStyles from "components/glamclub/StoreFront.module.scss";
import { StarRating } from "./StarRating";

export class StoreFrontItem extends React.Component {
  friendlyUrl = (url) => {
    return url.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "-").replace(/^-+|-+$/g, '');
  };

  render () {
    const { productData } = this.props;

    let friendlyName = this.friendlyUrl(productData.productVariantName);
    
    let pathTo = `/produtos/${productData.productId}/${productData.productVariantId}/${friendlyName}`;

    let imageUrl = productData.defaultImageURL.replace(/\_SML/, "_BIG");

    return (
      <NavLink to={pathTo} className={StoreFrontStyles["product-item"]}>
        <div className={StoreFrontStyles["product-item__thumb"]}>
          <img src={imageUrl} alt={""}/>
        </div>
        <div className={StoreFrontStyles["product-item__info"]}>
          <p className={StoreFrontStyles["product-item__brand-name"]}>
          {productData.brandName}
          </p>
          <p className={StoreFrontStyles["product-item__name"]}>
            {productData.productVariantName}
          </p>
          <span className={StoreFrontStyles["product-item__price"]}>
            {productData.tradePoints} Glampoints
          </span>
          <StarRating className={StoreFrontStyles["product-item__stars"]} 
            rating={productData.ratingAverage}/>
        </div>
      </NavLink>
    );
  }
}
